import { render } from "./return-card.vue?vue&type=template&id=cc78794a"
import script from "./return-card.vue?vue&type=script&lang=js"
export * from "./return-card.vue?vue&type=script&lang=js"

import exportComponent from "/home/dev.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__